<!-- =========================================================================================
    File Name: Table.vue
    Description: Table demo - Imports all table demos
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div>
      <vx-card>
        <vs-table pagination :max-items="maxItem" search :data="importLogs">

          <template slot="header">
            <!-- ITEMS PER PAGE -->
            <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
              <vs-dropdown vs-trigger-click class="cursor-pointer">
                <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                  <span class="mr-2">{{ $t("sections.system.dataForm.limit", {maxItem, total: importLogs.length}) }}</span>
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="maxItem = value" :key="i" v-for="(value, i) in maxItemsOption">
                    <span>{{ value }}</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </template>
          <template slot="thead">
            <vs-th sort-key="email">{{ $t("sections.system.dataForm.account.email") }}</vs-th>
            <vs-th sort-key="importCode">{{ $t("sections.system.dataForm.importCode") }}</vs-th>
            <vs-th sort-key="importType">{{ $t("sections.system.dataForm.importType") }}</vs-th>
            <vs-th sort-key="fileName">{{ $t("sections.system.dataForm.fileName") }}</vs-th>
            <vs-th sort-key="success">{{ $t("sections.system.dataForm.countingSuccess") }}</vs-th>
            <vs-th sort-key="createdAt">{{ $t("sections.system.dataForm.createdAt") }}</vs-th>
            <vs-th sort-key="status">{{ $t("sections.system.dataForm.status") }}</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="res" :key="index" v-for="(res, index) in data">
              <vs-td :data="res.account.email">
                {{ res.account.email }}
              </vs-td>
              <vs-td :data="res.importCode">
                {{ res.importCode }}
              </vs-td>
              <vs-td :data="res.importType">
                {{ res.importType }}
              </vs-td>
              <vs-td :data="res.fileName">
                {{ res.fileName }}
              </vs-td>
              <vs-td :data="res | countingSuccess">
                {{ res | countingSuccess }}
              </vs-td>
              <vs-td :data="res.createdAt">
                {{ res.createdAt }}
              </vs-td>
              <vs-td :data="res.status">
                <vs-chip :color="getStatusAction(res.status).color" class="product-order-status">{{ getStatusAction(res.status).txt }}</vs-chip>
              </vs-td>
              <template slot="expand">
                <div class="w-full">
                  <pre>{{ res.payload | pretty }}</pre>
                </div>
              </template>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const {mapActions: mapSystemActions, mapState: mapSystemState } = createNamespacedHelpers('System')

export default {
  data () {
    return {
      maxItem: 10,
      maxItemsOption: [5, 10, 20, 100],
    }
  },
  filters: {
    pretty: function(res) {
      return JSON.stringify(JSON.parse(res), null, 2);
    },
    countingSuccess: function(res) {
      return `${res.success}/${res.row}`
    }
  },
  async created () {
    await this.getImportLogs()
    this.pms ('SystemImportLog', 'visible', 'r')
  },
  computed: {
    ...mapSystemState(['importLogs', 'status'])
  },
  methods: {
    ...mapSystemActions(['getImportLogs', 'deleteImportLog']),
    async del (id) {
      this.actionID = id
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$t('notification.confirm-delete-title'),
        text: this.$t('notification.confirm-delete-message'),
        accept: this.acceptDel
      })
    },
    async acceptDel () {
      const vm = this
      vm.$vs.loading()
      await vm.deleteImportLog({
        form: {
          id: vm.actionID
        },
        vm: vm
      })
      await setTimeout(() => {
        vm.$vs.loading.close()
      }, 150)
    },
  }
}
</script>
